export const maxTimeout = 240000;
export const pollingInterval = 3000;
